import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

function InjectMassage(props) {
 return <FormattedMessage {...props} />
};
export default injectIntl(InjectMassage, {
  withRef: false,
});
